module.exports = __webpack_public_path__ + "static/media/al3.49b7b264.mp4";